<template>
  <div v-if="materiel">
    <div class="card">
      <header class="header-card">
        <p>
          {{ $t('materiel.caracteristiques') }}
        </p>
      </header>
      <div class="card-content columns is-multiline">
        <div class="column is-2 mgb-20px">
          <app-logo
            :canConserveAncienne="true"
            @hasNewFile="logoChanged">
          </app-logo>
        </div>
        <div class="column is-10 is-multiline">
          <div class="columns">
            <div class="column is-4">
              <b-field :label="$t('materiel.code')"
                :class="{'obligatoire' : !societeActive.masqueCodeMateriel}">
                <b-input v-model="materiel.code"></b-input>
              </b-field>
            </div>
            <div class="column is-4">
              <b-field
                :label="$t('materiel.typeMateriel')"
                :type="typeField"
                :message="message"
                class="obligatoire">
                <b-select v-model="materiel.typeId" expanded @input="majNumerique()">
                  <optgroup :label="$t('materiel.typePapier')"
                    class="is-size-7 has-text-icon-more has-text-weight-light">
                    <option v-for="materiel in listeMaterielTypeNonNumerique"
                            :value="materiel.id" :key="materiel.id">
                      {{ materiel.libelle }}
                    </option>
                  </optgroup>
                  <optgroup :label="$t('materiel.typeNumerique')"
                    class="is-size-7 has-text-icon-more has-text-weight-light">
                    <option v-for="materiel in listeMaterielTypeNumerique"
                            :value="materiel.id" :key="materiel.id">
                      {{ materiel.libelle }}
                    </option>
                  </optgroup>
                </b-select>
              </b-field>
            </div>
            <div class="column is-4">
              <b-field :label="$t('materiel.disposition')">
                <b-input v-model="materiel.disposition"></b-input>
              </b-field>
            </div>
          </div>
          <div class="columns is-multiline">
            <div class="column is-4">
              <parametre-autocomplete
                :label="$t('materiel.localisation')"
                v-model="materiel.localisationId"
                :target="constantes.PARAMETRES_KEYS.materielLocalisation"
              />
            </div>
            <div class="column is-4">
              <b-field :label="$t('materiel.venantDe')">
                <b-input v-model="materiel.enVenantDe"></b-input>
              </b-field>
            </div>
            <div class="column is-4">
              <b-field :label="$t('materiel.allantVers')">
                <b-input v-model="materiel.enAllantVers">
                </b-input>
              </b-field>
            </div>
            <div class="column is-4">
              <b-field :label="$t('materiel.tags')">
                <query-tags-tag-input
                  v-model="materiel.tags"
                  :tooltipLabel="$t('materiel.tagInfo')"
                  :moduleTag="constantes.MODULE_TAG_DISPOSITIF"
                  position="is-right"
                  field="tag">
                </query-tags-tag-input>
              </b-field>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="materiel.numerique && materiel.numeriqueDevice">
      <div class="mgt-20px">
        <p class="has-text-primary is-italic is-size-5">
          {{ $t('materiel.numeriqueDevice.title') }}
        </p>
      </div>
      <div class="columns mgt-10px">
        <div class="column is-4">
          <b-field :label="$t('materiel.numeriqueDevice.timeLoop')">
            <b-input class="inputCurrency"
              v-model="materiel.informationsNumeriques.timeLoop" disabled>
            </b-input>
          </b-field>
        </div>
        <div class="column is-4">
          <b-field :label="$t('materiel.numeriqueDevice.spotNumber')">
            <b-input class="inputCurrency"
            v-model="materiel.informationsNumeriques.spotNumber" disabled>
            </b-input>
          </b-field>
        </div>
        <div class="column is-4">
          <b-field :label="$t('materiel.numeriqueDevice.timeSpot')">
            <b-input class="inputCurrency"
              v-model="materiel.informationsNumeriques.timeSpot" disabled>
            </b-input>
          </b-field>
        </div>
      </div>
    </div>
    <div class="mgt-30px">
      <format :materiel="materiel">
      </format>
    </div>
    <div class="mgt-30px">
      <tlpe :materiel="materiel">
      </tlpe>
    </div>
    <div class="mgt-30px">
      <montage-demontage :dispositifPublicitaire="materiel"
        @etatMontageDemontageChanged="changeEtatTlpe()">
      </montage-demontage>
    </div>
    <div class="mgt-30px">
      <collectivite :materiel="materiel">
      </collectivite>
    </div>
    <div class="card mgt-30px">
      <header class="header-card">
        <p>
          {{ $t('materiel.visibilite') }}
        </p>
      </header>
      <div class="card-content columns is-multiline">
        <div class="columns column is-multiline is-3">
          <div class="column is-12 pdb-0">
            <b-field :label="$t('materiel.visibleSurLa')">
              <b-select v-model="materiel.visibleSurLa" expanded>
                <option v-for="visisble in visibleSurLa"
                        :value="visisble.value" :key="visisble.value">
                  {{ $t(visisble.libelle) }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-12 pdb-0">
            <parametre-autocomplete
              :label="$t('materiel.angleVision')"
              v-model="materiel.angleVisionId"
              :target="constantes.PARAMETRES_KEYS.materielAngleVision"
            />
          </div>
          <div class="column is-12 pdb-0">
            <gestion-azimut v-model="materiel.azimut"/>
          </div>
        </div>
        <div class="column is-9">
          <gmap-map class="is-height-250px" :center="center"
              :zoom="adresse !== null && adresse.longitude !== null && adresse.latitude !== null
              ? zoomDefault : zoomDefaultSansMarker">
            <div v-if="adresse && adresse.longitude && adresse.latitude">
              <gmap-marker :key="m.num" v-for="(m) in markers"
                :position="m.position" :icon="m.icon">
              </gmap-marker>
            </div>
          </gmap-map>
        </div>
        <div class="columns column is-12 is-multiline">
          <div class="column is-4">
            <b-checkbox class="mgt-10px" v-model="materiel.visibleDunFeu">
              <p class="has-text-default has-text-weight-bold">
                {{ $t('materiel.visibleFeu') }}
              </p>
            </b-checkbox>
          </div>
          <div class="column is-4">
            <b-checkbox class="mgt-10px" v-model="materiel.visibleDuneIntersection">
              <p class="has-text-default has-text-weight-bold">
                {{ $t('materiel.visibleIntersection') }}
              </p>
            </b-checkbox>
          </div>
          <div class="column is-4">
            <b-checkbox class="mgt-10px" v-model="materiel.eclaire">
              <p class="has-text-default has-text-weight-bold">
                {{ $t('materiel.eclaire') }}
              </p>
            </b-checkbox>
          </div>
        </div>
      </div>
    </div>
    <div class="card mgt-30px">
      <header class="header-card">
        <p>
          {{ $t('materiel.axe') }}
        </p>
      </header>
      <div class="card-content columns is-multiline">
        <div class="column is-4">
          <b-field :label="$t('materiel.isolement')">
            <b-select v-model="materiel.isolement" expanded>
              <option v-for="iso in isolement"
                      :key="iso.value"
                      :value="iso.value">
                {{ $t(iso.libelle) }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-4">
          <b-field :label="$t('materiel.ecartAxe')">
            <b-input v-model="materiel.ecartAxe" type="number" :use-html5-validation="false">
            </b-input>
          </b-field>
        </div>
        <div class="column is-4">
          <b-field :label="$t('materiel.ecartVoie')">
            <b-input v-model="materiel.ecartVoie" type="number" :use-html5-validation="false">
            </b-input>
          </b-field>
        </div>
        <div class="column is-4">
          <b-field :label="$t('materiel.longueurApproche')">
            <b-input v-model="materiel.longueurApproche" type="number"
                     :use-html5-validation="false">
            </b-input>
          </b-field>
        </div>
      </div>
    </div>
    <div class="card mgt-30px">
      <header class="header-card">
        <p>
          {{ $t('materiel.commentaire') }}
        </p>
      </header>
      <div class="card-content columns is-multiline">
        <div class="column is-12">
          <b-input type="textarea" v-model="materiel.commentaire"></b-input>
        </div>
      </div>
    </div>
    <div class="card mgt-30px">
      <header class="header-card">
        <p>
          {{ $t('adresseEmplacement.pj') }}
        </p>
      </header>
      <div class="card-content">
        <app-pieces-jointes class="mgt-20px" deletable
                            :checkPermissions=checkPermissions(permEmplacement.maj)>
        </app-pieces-jointes>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import Logo from '@/components/general/Logo';
import montageDemontage from '@/components/gabed/dispositif/montageDemontage';
import PiecesJointes from '@/components/general/piecesJointes';
import { EMPLACEMENT } from '@/configuration/gabed/permissionsGabedConf';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import { VISIBLE_SUR_LA, ISOLEMENT, DECLARATION_EN_ATTENTE } from '@/configuration/gabed/materiel/materielConf';
import messageErreur from '@/services/general/messageErreur';
import tlpe from '@/components/gabed/materiel/editionMateriel/tlpe';
import format from '@/components/gabed/materiel/editionMateriel/format';
import collectivite from '@/components/gabed/materiel/editionMateriel/collectivite';
import gestionAzimut from '@/components/general/gestionAzimut';
import centerMapGetter from '@/services/general/map/centerMapGetter';
import markersGetter from '@/services/general/map/markersGetter';
import { MONTE, DEMONTE } from '@/configuration/gabed/dispositif/dispositifPublicitaire';
import {
  ZOOM_DEFAULT_EMPLACEMENT,
  CENTER_DEFAULT,
  ZOOM_DEFAULT_SANS_MARKER,
  COULEUR_PUCE_DEFAULT,
} from '@/configuration/general/carteConf';
import QueryTagsTagInput from '@/components/general/tagInput/queryTagsTagInput';
import { DISPOSITIF as MODULE_TAG_DISPOSITIF } from '@/configuration/parametrage/tagConf';
import parametreAutocomplete from '@/components/general/autocomplete/parametreAutocomplete';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';

const Parametres = createNamespacedHelpers('parametres');
const permissions = createNamespacedHelpers('permissions');
const Attachments = createNamespacedHelpers('attachments');
const Societe = createNamespacedHelpers('societe');

export default {
  name: 'm_materiel',
  props: {
    materiel: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      permEmplacement: EMPLACEMENT,
      visibleSurLa: VISIBLE_SUR_LA,
      isolement: ISOLEMENT,
      zoomDefault: ZOOM_DEFAULT_EMPLACEMENT,
      zoomDefaultSansMarker: ZOOM_DEFAULT_SANS_MARKER,
      constantes: {
        MODULE_TAG_DISPOSITIF,
        PARAMETRES_KEYS,
      },
    };
  },
  methods: {
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    majNumerique() {
      if (!this.materiel.typeId) {
        this.materiel.numerique = false;
        this.materiel.declarableEnMairie = false;
        return;
      }

      /*
      * Un materiel peut etre définie en numérique uniquement à la création, lors d'une
      * modification il est possible de changer le type mais impossible de changer
      * la variable numérique du materiel à cause des faces
      */
      if (this.$route.name === 'm.gabed.emplacement-materielEdition') return;

      this.materiel.numerique = this.loadMaterielType.find((type) => {
        return this.materiel.typeId === type.id;
      }).numerique;
      this.materiel.declarableEnMairie = !this.materiel.numerique;
    },
    logoChanged(value) {
      this.$emit('hasNewLogo', value);
    },
    changeEtatTlpe() {
      switch (this.materiel.etat) {
        case MONTE:
          this.materiel.etatMontageTlpe = DECLARATION_EN_ATTENTE;
          break;
        case DEMONTE:
          this.materiel.etatDemontageTlpe = DECLARATION_EN_ATTENTE;
          break;
        default:
          break;
      }
    },
  },
  components: {
    parametreAutocomplete,
    collectivite,
    appLogo: Logo,
    montageDemontage,
    appPiecesJointes: PiecesJointes,
    tlpe,
    format,
    gestionAzimut,
    QueryTagsTagInput,
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...Societe.mapGetters({
      societeActive: 'societeActive',
    }),
    loadMaterielType() {
      return this.parametre(
        typesParametres.PARAMETRES_KEYS.materielType,
      );
    },
    listeMaterielTypeNumerique() {
      return this.loadMaterielType.filter((type) => {
        return type.id === this.materiel.typeId || (type.numerique && type.actif);
      });
    },
    listeMaterielTypeNonNumerique() {
      return this.loadMaterielType.filter((type) => {
        return type.id === this.materiel.typeId || (!type.numerique && type.actif);
      });
    },
    center() {
      if (this.adresse !== null
        && this.adresse.longitude !== null
        && this.adresse.latitude !== null) {
        return centerMapGetter(this.adresse, this.markers);
      }
      return centerMapGetter(CENTER_DEFAULT, []);
    },
    adresse() {
      if (this.materiel === null) return null;
      if (this.materiel.dispositif === null) return null;
      return this.materiel.dispositif.adresse;
    },
    markers() {
      return markersGetter(this.adresse, COULEUR_PUCE_DEFAULT, this.materiel.azimut);
    },
    currentMaterielType() {
      return this.loadMaterielType.find(t => t.id === this.materiel.typeId);
    },
    message() {
      return (this.currentMaterielType && !this.currentMaterielType?.actif) ? this.$t('general.messages.warning.archive') : '';
    },
    typeField() {
      return (this.currentMaterielType && !this.currentMaterielType?.actif) ? 'is-warning' : '';
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.setAttachmentContext({ module: 'Materiel' });
      await this.loadParametres([typesParametres.PARAMETRES_KEYS.materielType,
        typesParametres.PARAMETRES_KEYS.materielFormat]);
      if (this.$route.params.idMateriel) {
        await this.setAttachmentElementId({ id: this.$route.params.idMateriel });
      }
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
